import React, { useEffect, useRef } from 'react';
import { Table, Pagination, PagingQuery, Affix } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import { useIntl } from 'umi';

interface TopchartTableProps {
  loading: boolean;
  records: any[];
  columns: any[];
  tableTotal: number;
  pageIndex: number;
  pageSize: number;
  pageSizeOptions?: number[];
  onPagingChange: (e: PagingQuery) => void;
  className?: string;
  recordKey?: string;
  nodataDom?: React.ReactNode; // 无数据展示自定义
  tableAddons: any[]; // 根据tableAddons的实际数据类型进行定义
}

export default function CustomTable(props: TopchartTableProps) {
  const {
    loading,
    records,
    nodataDom,
    className,
    recordKey,
    columns,
    // pageSizeOptions = [20, 50, 100],
    pageSizeOptions = [10, 20, 30, 50, 100, 200],
    onPagingChange,
    pageSize,
    pageIndex,
    tableTotal,
    tableAddons,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  const loadingOrNodata = loading || !records?.length;

  // console.log('CustomTableCustomTable',props);

  // const bottomAffixRef = useRef(null);
  // useEffect(() => {
  //   const handleScroll = () => {
  //     bottomAffixRef.current.update();
  //   };
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  return (
    <div style={{ position: 'relative' }}>
      {/* 添加覆盖NoData，不随表格滚动 */}
      <div
        style={{
          display: loadingOrNodata ? 'block' : 'none',
          position: 'absolute',
          width: '-webkit-fill-available',
          zIndex: 9999,
          textAlign: 'center',
          bottom: 122,
        }}
      >
        {loading ? (
          <Loading />
        ) : !records?.length ? (
          nodataDom ? (
            nodataDom
          ) : (
            formatMessage({ id: 'common_nodata' })
          )
        ) : (
          ''
        )}
      </div>
      <>
        <Table
          recordKey={recordKey}
          className={className}
          bordered="all"
          records={records}
          columns={columns}
          addons={tableAddons}
        />
        {/* <Affix
          ref={bottomAffixRef}
          offsetBottom={0}
          target={() => {
            return document.querySelector('.affix-target');
          }}
        >
          钉在底部
        </Affix> */}
      </>
      <Pagination
        pageSizeOptions={pageSizeOptions}
        onPagingChange={onPagingChange}
        pageSize={pageSize}
        pageIndex={pageIndex}
        recordCount={tableTotal}
        stateTextVisible={true}
        pageSizeVisible={tableTotal > pageSizeOptions[0]}
        pageIndexVisible={tableTotal > pageSizeOptions[0]}
        jumpVisible={tableTotal > pageSizeOptions[0]}
        endJumpVisible={tableTotal > pageSizeOptions[0]}
        stateText={formatMessage({ id: 'dbi_pagination_total' }, { total: tableTotal ?? 0 })}
      />
    </div>
  );
}
